import React from "react";
import { FieldValues  } from "react-hook-form";
import { FieldSectionConfig } from "../../../../../models/Models";
import Modal from "../../../../../context/modal/Modal";
import EditForm from "../form/EditForm";

interface EditModalProps<T extends FieldValues> {
    modalId: string;
    config: FieldSectionConfig<T>[]
    initialValues: T
    onSubmit: (data: T) => void
}

const EditModal = <T extends FieldValues>  ({
    config,
    initialValues,
    onSubmit,
    modalId,
}: EditModalProps<T>) => {
    return (
        <>
            <Modal modalTitle={`Edit`} modalId={modalId}>
                <EditForm modalId={modalId} config={config} initialValues={initialValues} onSubmit={onSubmit}/>
            </Modal>
        </>
    );
};

export default EditModal;
